<div mat-dialog-content>
    <div class="activity-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-tasActivityNew (closeDialog)="onClose()" [activityId]="activityId" [taskId]="taskId"></app-tasActivityNew>
</div>